let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("76n7a"), load("l253H"), load("279sZ")]).then(() => parcelRequire('4XV6O'));